import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { type ApiPaginate, CardsApi, RequestStrategyEnum, type CardResponse, type CardsRequest, type WithSignal } from '@shared/api';

const getCardsEffect = createEffect(({ signal, ...request }: WithSignal<CardsRequest> = {}) => CardsApi.getCards(request, signal));

const clearEvent = createEvent();

const $dataStore = createStore<ApiPaginate<CardResponse[]> | null>(null)
  .on(getCardsEffect.done, (_, data) => data.result || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getCardsEffect.pending, (_, data) => data)
  .on(getCardsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getCardsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCardsEffect, () => null)
  // .on(getCardsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCardsEffect.fail, () => 'Something went wrong while fetching Cards. Please try again.')
  .on(getCardsEffect.done, () => null)
  .reset(clearEvent);

const getCardsApi = ApiUtils.wrapperApi(getCardsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getCardsApi.cancel());

export const $cardListStore = {
  events: {
    getCards: getCardsApi.trigger,
    clear: clearEvent,
  },
  clear: clearEvent,
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
